<template>
  <div>
    <!-- <h3>计划{{index + 1}}</h3> -->
    <a-form-model layout="horizontal" :model="form" :colon="false" :rules="formRule" ref="form" :label-col="{ span: 3 }" :wrapper-col="{ lg: 6, sm: 8 }">
        <a-form-model-item label="基础保障方案选择" :wrapper-col="{ span: 21 }">
            <!-- // 单选 -->
            <a-radio-group v-model="form.plan" :disabled="disabledAll">
                <a-radio v-for="item in planList" :key="item.code" :value="item.code">{{item.name}}</a-radio>
            </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="可选福利" :wrapper-col="{ span: 21 }">
            <div>
                <a-checkbox v-model="form.checkyake" :disabled="disabledAll">牙科福利</a-checkbox>
                <a-radio-group v-if="form.checkyake" v-model="form.yake" :disabled="disabledAll">
                    <a-radio v-for="item in yakeList" :key="item.code" :value="item.code">{{item.name}}</a-radio>
                </a-radio-group>
            </div>
            <div>
                <a-checkbox v-model="form.checktijian" :disabled="disabledAll">体检福利</a-checkbox>
                <a-radio-group v-if="form.checktijian" v-model="form.tijian" :disabled="disabledAll">
                    <a-radio v-for="item in tijianList" :key="item.code" :value="item.code">{{item.name}}</a-radio>
                </a-radio-group>
            </div>
            <div>
                <a-checkbox v-model="form.checkyanke" :disabled="disabledAll">眼科福利</a-checkbox>
            </div>
            <div>
                <a-checkbox v-model="form.checkkongbu" :disabled="disabledAll">战争和恐怖主义福利</a-checkbox>
            </div>
        </a-form-model-item>
        <div>
            <h4>费率信息</h4>
            <div class="rate-tips">
                <p>1.主被保险人的配偶或子女（子女投保时应未满24岁）可作为本合同附属被保险人。0-17 岁子女只能以附属被保险人身份入保。</p>
                <p>2.入保年龄在 60-65 岁之间的被保险人，另加收 15%保费；入保年龄在 66-70 岁之间的被保险人，加收 30%保费；入保年龄超过70岁的被保险人，加收 50%保费；</p>
                <p>3.SPF亲子指一位家长携带一至二名子女，如果一位家长携带两名以上子女，则使用“family家庭”费率。若家庭携带子女人数超过三名，将加收该家庭保费的 14.4%。</p>
            </div>
            <a-table size="small" :rowKey="'familyType'" :data-source="quotationInsuredList" :columns="baseRate" :locale="{emptyText: '暂无数据'}" :pagination="false">
                <div slot="operation" slot-scope="text, record, index">
                    <a-button type="danger" ghost size="small" v-if="!disabledAll" @click="deleteRateItem(index)">删除</a-button>
                </div>
            </a-table>
            <div>
                <a-button type="primary" size="small" v-if="!disabledAll" @click="addRateItem">添加费率</a-button>
            </div>
        </div>
        <a-form-model-item :label="`计划${index + 1}总保费`" class="plan-premium">
            <a-input v-model="form.sum_premium" :disabled="disabledAll" suffix="元" read-only></a-input>
        </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
import initData from './data'
export default {
    props: {
        count: {
            type: Number,
            default: 0
        },
        index: {
            type: Number,
            default: 0
        },
        disabledAll: {
            required: true,
            type: Boolean
        },
        riskInfo: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data() {
        const currInitData = this.$lodash.cloneDeep(initData)
        console.log(currInitData)
        const baseRate = [
            { align: 'center', title: '被保人类型', width: 130, dataIndex: 'familyType', customRender: (val, row, index) => {
                return (
                    <a-select v-model={this.quotationInsuredList[index].familyType} disabled={this.disabledAll}>
                        {this.familyTypeCode.map(item => {
                            return  <a-select-option value={item.code}>{item.name}</a-select-option>
                        })}
                    </a-select>
                )
            }},
            { align: 'center', title: '主被保人年龄', width: 130, dataIndex: 'm_age', customRender: (val, row, index) => {
                return (
                    <a-select v-model={this.quotationInsuredList[index].m_age} disabled={this.disabledAll}>
                        {this.ageCode.map(item => {
                            return  <a-select-option value={item}>{item}</a-select-option>
                        })}
                    </a-select>
                )
            }},
            { align: 'center', title: '配偶年龄', width: 130, dataIndex: 'p_age', customRender: (val, row, index) => {
                const isDisabled = ['single', 'spf'].indexOf(row.familyType) > -1 // single spf 不能有配偶
                if (isDisabled) {this.quotationInsuredList[index].p_age = '0'}
                return (
                    <a-select v-model={this.quotationInsuredList[index].p_age} disabled={this.disabledAll || isDisabled}>
                        {this.ageCode.map(item => {
                            return  <a-select-option value={item}>{item}</a-select-option>
                        })}
                    </a-select>
                )
            }},
            { align: 'center', title: '子女人数', width: 130, dataIndex: 'c_num', customRender: (val, row, index) => {
                const isDisabled = ['single', 'couple'].indexOf(row.familyType) > -1 // single couple 不能有子女
                if (isDisabled) {this.quotationInsuredList[index].c_num = '0'}
                return (
                    <a-input v-model={this.quotationInsuredList[index].c_num}  disabled={this.disabledAll || isDisabled} onblur={() => {this.getPremiumData(index, 'c_num')}} />
                )
            }},
            { align: 'center', title: '份数', dataIndex: 'mult', width: 100, customRender: (val, row, index) => {
                return (
                    <a-input v-model={this.quotationInsuredList[index].mult} onblur={() => {this.getPremiumData(index, 'mult')}} disabled={this.disabledAll} />
                )
            }},
            { align: 'center', title: '基础保费', width: 80, dataIndex: 'a_pm'},
            { align: 'center', title: '可选保费', width: 80, dataIndex: 'b_pm'},
            { align: 'center', title: '保费', dataIndex: 'premium'},
            { title: '', key: "operation", align: "center", width: "100px", scopedSlots: { customRender: "operation" }}
        ]
        return {
            ...currInitData,
            baseRate,
            basePremium: {},
            form: {
                plan: 'Greater China',
                checkyake: true,
                checktijian: false,
                checkyanke: false,
                checkkongbu: false,
                yake: '2000',
                tijian: '1600',
                has_single: false,
                has_spf: false,
                has_family: false,
                has_couple: false,
                pNum: 0
            },
            formRule: {},
            cradTypeCode: [],
        }
    },
    watch: {
        count(val) {
            console.log(this.riskInfo, '000'+this.index)
            if (val) {
                const { insList, ...formData } = this.riskInfo
                this.quotationInsuredList = insList || this.quotationInsuredList,
                this.form = {
                    ...this.form,
                    ...formData
                }
            }
        }
    },
    mounted() {
        // this.onPlanChange('Greater China')
    },
    methods: {
        // 删除费率表行
        deleteRateItem(index) {
            this.quotationInsuredList.splice(index, 1)
        },
        // 添加费率行
        addRateItem() {
            const data = {
                familyType: 'single', // 被保人类型
                m_age: '0-59', // 主被保人年龄段
                p_age: '0', // 配偶年龄段
                c_num: '0', // 子女人数
                mult: '0', // 份数
                premium: '0' // 保费
            }
            this.quotationInsuredList.push(data)
        },
        // 输入框blur 校验正整数 计算人数并获取费率信息
        getPremiumData(index, prop) {
            const val = this.quotationInsuredList[index][prop]
            const originVal = this.riskInfo[index] && this.riskInfo[index][prop] || '0'
            if (!/^[0-9]+$/.test(val)) {
                this.$message.error('请输入正整数')
                this.quotationInsuredList[index][prop] = originVal
            } else if (prop === 'c_num' && parseInt(val) > 5) {
                this.$message.error('子女人数最大为5')
                this.quotationInsuredList[index][prop] = originVal
            }
        },
        // 校验并调接口计算费率
        getRatePremium() {
            if (!this.quotationInsuredList || !this.quotationInsuredList.length) {
                this.$message.error(`计划${this.index + 1}请先添加费率信息`);
                return false;
            }
            this.form["has_single"] = this.form["has_spf"] = this.form["has_couple"]= this.form["has_family"] = false
            let pNum = 0
            for(let i = 0; i < this.quotationInsuredList.length; i ++) {
                let { mult, c_num, familyType } = this.quotationInsuredList[i]
                mult = parseInt(mult)
                c_num = parseInt(c_num)
                if(mult <= 0) {
                    this.$message.error(`计划${this.index + 1}请输入份数`)
                    return false;
                }
                const isC_numMust = ['spf', 'family'].indexOf(familyType) > -1 // spf family 必须要有子女
                if (isC_numMust && mult && !c_num) {
                    this.$message.error(`计划${this.index + 1}被保人类型是SPF亲子或Family家庭时, 子女人数不能为0`)
                    return false;
                }
                const prop = 'has_' + familyType
                this.form[prop] = true
                pNum += mult
            }
            this.form.pNum = pNum
            return true
        },
        // 向父组件提交数据
        submitHandler() {
            return new Promise((resolve, reject) => {
                const isValid = this.getRatePremium()
                if (!isValid) {
                    reject(new Error())
                }
                let data = {};
                data[this.index] = {
                    ...this.form,
                    insList: this.quotationInsuredList,
                    // attach: this.optionalRateData
                }
                resolve(data)
                this.$emit('collectData', data)
            })
        },
    }
}
</script>

<style lang="scss" scoped>
::v-deep .ant-table{
    font-size: 12px;
    border: none;
    margin-top: 20px;
    .ant-input{
        width: 100%;
    }
    tr > td,
    tr > th{
        border: none;
        padding: 5px !important;
    }
}
.plan-premium{
    margin: 20px 0 0;
}
p{
    margin: 0
}
.rate-tips{
    color: #fa3d3d;
    line-height: 1.5;
}
</style>